"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var Grid_1 = __importDefault(require("@material-ui/core/Grid"));

var Typography_1 = __importDefault(require("@material-ui/core/Typography"));

var ViewWrapper = function ViewWrapper(props) {
  return react_1.default.createElement(Grid_1.default, {
    container: true,
    spacing: 3,
    alignItems: "center"
  }, react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 12,
    sm: 4
  }, react_1.default.createElement(Typography_1.default, null, props.label)), react_1.default.createElement(Grid_1.default, {
    item: true,
    xs: 12,
    sm: 8
  }, props.children));
};

ViewWrapper.propTypes = {
  label: prop_types_1.default.string.isRequired,
  children: prop_types_1.default.oneOfType([prop_types_1.default.arrayOf(prop_types_1.default.node), prop_types_1.default.node]).isRequired
};
exports.default = ViewWrapper;